import { IConfig } from '@cian/config/shared';

export const getSupportedDocumentMimeTypes = (config: IConfig): string[] => {
  return config.get<string[]>('frontend-chats.SupportedDocumentMimeTypes') || [];
};

export const getSupportedImageMimeTypes = (config: IConfig): string[] => {
  const mimeTypesList = getSupportedDocumentMimeTypes(config);

  return mimeTypesList.filter(type => type.includes('image'));
};
